import { IconProps } from '../icon-props-interface';

export const IconClose = ({ color = 'var(--color-primary-3)' }: IconProps): JSX.Element => (
    <svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
        <path d="M1 1L9 9M9 1L1 9" stroke={color} strokeWidth="1.2" strokeLinecap="round" />
    </svg>
);

export default IconClose;
